import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const CbCoCreate = () => {
    return (
        <div className='row pt-20 px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`Co-create`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20' style={{}}>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                If you have a solid plan to create any exceptional AI Agents, we can partner to co-create them. 
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                We bring the AI expertise and you bring your wares - domain specialty, business expertise, complementary products or so.
                            </li>
                            <li className="d-flex text-gray-700 fs-3">
                                <FontAwesomeIcon icon={faCircleCheck} className="me-2 mt-1" />
                                <span>
                                    Write to&nbsp;
                                    <a href="mailto:sales@truvoice.ai" className="text-decoration-underline text-primary">
                                    sales@truvoice.ai
                                    </a>
                                    &nbsp;with your business proposal for us to evaluate.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto py-10'>
                    <img src="/assets/img/co-create.jpg" alt="app image" className="radius-20 w-80" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {CbCoCreate}